import { render } from "./FramesColor.vue?vue&type=template&id=bc2f0d90&scoped=true"
import script from "./FramesColor.vue?vue&type=script&lang=js"
export * from "./FramesColor.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=bc2f0d90&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2f0d90"]])

export default __exports__